import React from "react";
import "./../Login/login.css";
import { useFormik } from "formik";
import * as yup from "yup";
import { TextField, Button, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "react-i18next";

// import Button from "@material-ui/core/Button";
// import TextField from "@material-ui/core/TextField";



const Register = () => {
    const { t } = useTranslation();

    const validationSchema = yup.object({
        email: yup
            .string(t('register.enterEmail'))
            .email(t('register.emailInvalid'))
            .required(t('register.emailRequired')),
        password: yup
            .string(t('register.enterPassword'))
            .min(8, t('register.passwordMin'))
            .required(t('register.passwordRequired')),
    });

    const formik = useFormik({
        initialValues: {
            email: "foobar@example.com",
            password: "foobar",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (
        <>
            <Grid container spacing={2} justifyContent="center" rowSpacing={1}>
                <Grid item md={5}>
                    <div className="login_page">

                        {/* <Typography variant="h4" component="h2" gutterBottom>
        Login Page
      </Typography> */}
                        <img
                            src={require("../../images/logo.png")}
                            className="logo"
                            alt="logo"
                        />
                        <h3>{t('register.title')}</h3>
                        <p>{t('register.tagline')}</p>

                        <form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={5} rowSpacing={1}>
                                <Grid item md={6}>
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.firstName')}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        id="email"
                                        name="email"
                                        placeholder={t('register.firstNamePlaceholder')}
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.touched.email && formik.errors.email}

                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.lastName')}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        id="password"
                                        name="password"
                                        placeholder={t('register.lastNamePlaceholder')}
                                        type="password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.password && Boolean(formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.country')}
                                    </Typography>
                                    <FormControl fullWidth>

                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                        >
                                            <MenuItem value={10}>{t('register.optionTen')}</MenuItem>
                                            <MenuItem value={20}>{t('register.optionTwenty')}</MenuItem>
                                            <MenuItem value={30}>{t('register.optionThirty')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item md={6}>
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.state')}
                                    </Typography>
                                    <FormControl fullWidth>

                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                        >
                                            <MenuItem value={10} selected disabled>{t('register.selectState')}</MenuItem>
                                            <MenuItem value={10}>{t('register.optionTen')}</MenuItem>
                                            <MenuItem value={20}>{t('register.optionTwenty')}</MenuItem>
                                            <MenuItem value={30}>{t('register.optionThirty')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item md={12}>
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                        className="big_label"
                                    >
                                        {t('register.dateOfBirth')}
                                    </Typography>

                                </Grid>
                                <Grid item md="3">
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.month')}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        id="mm"
                                        name="text"
                                        placeholder={t('register.monthPlaceholder')}

                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}


                                    />
                                </Grid>
                                <Grid item md="3">
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.day')}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        id="mm"
                                        name="text"
                                        placeholder={t('register.dayPlaceholder')}

                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}


                                    />
                                </Grid>
                                <Grid item md="6">
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.year')}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        id="mm"
                                        name="text"
                                        placeholder={t('register.yearPlaceholder')}

                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}


                                    />
                                </Grid>
                                <Grid item md="12">
                                    <Typography
                                        variant="subtitle1"
                                        align="left"
                                    >
                                        {t('register.referredBy')}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        id="mm"
                                        name="text"
                                        placeholder={t('register.referralPlaceholder')}

                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}


                                    />
                                </Grid>
                                <Grid item md={12}>
                                    <div className="condition_check">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="" />
                                            <label className="form-check-label" for=""> {t('register.termsConfirmation')} <Link to="/">{t('register.termsAndConditions')}</Link>  {t('register.and')}  <Link to="/">{t('register.privacyPolicy')}</Link>. </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="" />
                                            <label className="form-check-label" for="">{t('register.receivePromotionalEmails')} </label>
                                        </div>
                                    </div>

                                </Grid>
                            </Grid>

                            <Button color="primary" variant="contained" type="submit">
                            {t('register.completeSignUp')}
                            </Button>

                            <p className="sign_p">{t('register.alreadyHaveAccount')}  <Link to="/signUp">{t('register.logIn')}</Link></p>

                        </form>
                    </div>
                </Grid>
            </Grid>

        </>
    );
};

export default Register;
